import { render, staticRenderFns } from "./write-paragraph.vue?vue&type=template&id=09057461&scoped=true"
import script from "./write-paragraph.vue?vue&type=script&lang=js"
export * from "./write-paragraph.vue?vue&type=script&lang=js"
import style0 from "./write-paragraph.vue?vue&type=style&index=0&id=09057461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09057461",
  null
  
)

export default component.exports